export {default} from "./Education"
